<template>
  <div class="createPlayStep">
    <div class="backBox">
      <img
        class="pointer"
        @click="clickLocalStep()"
        src="@/assets/thdImg/pages/back.svg"
        alt=""
      />
      <span class="backBox_name">{{ activityData.name }}</span>
    </div>
    <div class="formBox">
      <!-- 步骤条 -->
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="1">
          <el-step title="活动模板"></el-step>
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>
      <!--  活动条件表单部分 -->
      <div class="secondstep">
        <el-form
          :model="ruleForm"
          :rules="rules"
          class="backgroundForm"
          ref="ruleForm"
          label-width="120px"
        >
          <el-form-item label="活动名称:" required>
            <!-- prop="activityName" 活动名称 -->
            <el-input
              v-model="ruleForm.activityName"
              maxlength="50"
              show-word-limit
              placeholder="积分任务的展示名称"
              style="width: 400px"
            ></el-input>
          </el-form-item>

          <el-form-item label="活动时间:" required>
            <!-- prop="isLongTime" 活动开始时间-活动结束时间 -->
            <div class="my_select_time">
              <el-date-picker
                v-model="activityTimeValue"
                type="datetimerange"
                class="rangeTime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                ref="timeBox"
                @change="activityTimeChange"
                style="width: 400px; font-size: 12px"
                :picker-options="pickerOptionsValue"
                :default-time="defaultTime"
              >
              </el-date-picker>
              <i
                class="el-icon-circle-close date_icon1"
                @click="activityTimeValue = []"
              ></i>
              <img
                src="@/assets/images/select_date.svg"
                alt=""
                class="date_icon2"
              />
            </div>
            <span class="lastTime" style="color: #666">
              活动持续 <span style="color: #2670fb">{{ timeDay }}</span> 天
              <span style="color: #2670fb">{{ timeOut }}</span> 小时
              <el-tooltip
                class="item"
                effect="light"
                content="活动有效期不可超过订购有效期"
                placement="bottom"
              >
                <el-button type="text" style="width: 35px">
                  <i class="el-icon-question"></i>
                </el-button>
              </el-tooltip>
            </span>
          </el-form-item>
          <el-form-item label="活动对象:" required>
            <el-radio-group
              v-model="ruleForm.activityObject"
              :disabled="isStartEdit"
              @change="handleActivityObj"
            >
              <el-radio :label="0">不限</el-radio>
              <el-radio :label="1">指定身份</el-radio>
              <el-radio :label="2" disabled>指定人群</el-radio>
            </el-radio-group>
            <span class="margin-left-12">
              <el-popover
                placement="right-start"
                trigger="hover"
                content="您不满足使用该功能的条件，请联系专属客服了解~"
              >
                <el-button slot="reference" disabled>{{
                  selectCrowdText
                }}</el-button>
              </el-popover>
            </span>
          </el-form-item>
          <el-form-item
            label="新老客户:"
            required
            v-if="ruleForm.activityObject === 1"
          >
            <el-radio-group
              v-model="ruleForm.newOldCustomer"
              :disabled="isStartEdit"
            >
              <el-radio :label="0">不限</el-radio>
              <el-radio :label="1">新客</el-radio>
              <el-radio :label="2">老客</el-radio>
            </el-radio-group>
            <span class="margin-left-12">
              <span class="tips-style margin-left-12">新老客说明</span>
              <el-tooltip class="item" effect="light" placement="bottom">
                <span slot="content">
                  <div>历史订单中已完成订单的订单数为0则定义为新客</div>
                  <div>历史订单中已完成订单的订单数≥1则定义为新客</div>
                </span>
                <i class="el-icon-question margin-left-8"></i>
              </el-tooltip>
            </span>
          </el-form-item>
          <el-form-item
            label="参与对象:"
            prop="partner"
            v-if="ruleForm.activityObject == '1'"
          >
            <el-checkbox-group
              v-model="ruleForm.partner"
              @change="checkListchange"
              :disabled="isStartEdit"
            >
              <el-checkbox label="-1" name="partner">全部</el-checkbox>
              <el-checkbox
                label="0"
                name="partner"
                :disabled="ruleForm.partner == -1"
                >非会员</el-checkbox
              >

              <el-checkbox
                v-for="(item, index) in levelList"
                :key="index"
                :label="index + 1 + ''"
                name="partner"
                :disabled="ruleForm.partner == -1"
                >{{ item }}</el-checkbox
              >
            </el-checkbox-group>
            <span v-if="localStepNum == 3"
              >注：之前关注过店铺和未关注店铺的新粉丝可以参加活动，同一个活动只能参与一次</span
            >
          </el-form-item>
          <el-form-item
            label="入会时间:"
            v-if="ruleForm.activityObject == '1' && ruleForm.partner != 0"
          >
          <el-date-picker
            v-model="ruleForm.membershipTime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            start-placeholder="开始日期"
            type="datetime"
            :disabled="isEditOrDraft"
            placeholder="选择日期时间">
          </el-date-picker>
          之后成为会员的用户可参与活动
          </el-form-item>

          <el-form-item label="活动强制结束:" prop="test">
            <el-checkbox
              v-model="ruleForm.cutActivityWhileNoPrize"
              :disabled="isStartEdit"
              >全部奖品领取完强制结束活动</el-checkbox
            >
            <span class="warningTitele">
              <i class="el-alert__icon el-icon-info" style="color: #ebaa3c"></i>
              注：勾选后，所有奖品领取完毕后，活动会自动结束
            </span>
          </el-form-item>

          <el-form-item label="过滤规则:" prop="test">
            <div style="display: flex; align-items: center; height: 32px">
              <el-radio-group v-model="filterInviteOption">
                <el-radio :label="0">过滤同一活动中被邀请过的人</el-radio>
                <el-radio :label="1">过滤所有活动中被邀请过的人</el-radio>
              </el-radio-group>
              <el-popover placement="top-start" trigger="hover" width="400">
                <div>
                  <div>被邀请人过滤规则：</div>
                  <div>
                    1.过滤同一活动中被邀请过的人：即表示同一个人在同一个活动中仅能被有效邀请1次
                  </div>
                  <div>
                    2.过滤所有活动中被邀请过的人：即表示同一个人在所有活动中仅能被有效邀请1次
                  </div>
                </div>
                <i
                  slot="reference"
                  style="color: #ccc; margin-left: 10px"
                  class="el-icon-question"
                ></i>
              </el-popover>
            </div>
          </el-form-item>

          <el-form-item label="有效规则:" prop="test">
            <div style="display: flex; align-items: center; height: 32px">
              <el-radio-group v-model="validOption" @change="validOptionChange">
                <el-radio :label="0">被邀请人成功入会</el-radio>
                <el-radio :label="1">被邀请人成功入会且达到指定等级</el-radio>
              </el-radio-group>
              <el-checkbox-group
                style="margin-left: 20px"
                v-model="gradeOption"
                v-if="validOption == 1"
              >
                <el-checkbox
                  v-for="(item, index) in leveloptions"
                  :label="item.customerLevel.toString()"
                  :key="levelList"
                  >{{ item.customerLevelName }}</el-checkbox
                >
                <!-- <el-checkbox label="会员等级 B"></el-checkbox>
              <el-checkbox label="会员等级 C"></el-checkbox> -->
              </el-checkbox-group>
            </div>
          </el-form-item>

          <el-form-item label="奖品设置:" prop="setPrize">
            <el-radio
              v-model="ruleForm.isCumulativePrize"
              :label="false"
              :disabled="isStartEdit"
              >统一奖品</el-radio
            >
            <el-radio
              v-model="ruleForm.isCumulativePrize"
              :label="true"
              :disabled="isStartEdit"
              >梯度奖品</el-radio
            >
            <div class="prize_box">
              <template v-if="!ruleForm.isCumulativePrize">
                <div>
                  <span>奖品库存显示：</span>
                  <el-radio
                    :disabled="isStartEdit"
                    v-model="isShowRemanentAmount"
                    :label="0"
                    >不显示</el-radio
                  >
                  <el-radio
                    :disabled="isStartEdit"
                    v-model="isShowRemanentAmount"
                    :label="1"
                    >显示</el-radio
                  >
                  <el-popover placement="top-start" trigger="hover" width="450">
                    <div>
                      <div>
                        选中“显示”，则活动用户可在活动页面中查看奖品的剩余库存。
                      </div>
                    </div>
                    <i
                      slot="reference"
                      style="color: #ccc; margin-left: 10px"
                      class="el-icon-question"
                    ></i>
                  </el-popover>
                </div>
                <div style="margin-bottom: 10px" class="line">
                  <div>每邀请一人可得</div>
                  <div
                    v-if="
                      prizeSettingList.prizeType != 3 &&
                      prizeSettingList.prizeType != 10
                    "
                    style="color: #2670fb; margin: 0 10px"
                  >
                    {{ prizeSettingList.prizeTxt
                    }}{{ prizeSettingList.prizeType | prizeType }}
                  </div>
                  <div v-else style="color: #2670fb; margin: 0 10px">
                    {{ prizeSettingList.title }}
                  </div>
                  <div>，活动期间最多邀请</div>
                  <el-input
                    :disabled="isStartEdit"
                    v-model="ruleForm.peopleCount"
                    style="width: 70px; margin: 0 10px"
                    @input="ruleForm.peopleCount = getNumberData($event, 0)"
                  >
                    <!-- @input.native="checkputn" -->
                  </el-input>
                  <div>人，超出人数不再获得奖励</div>
                  <el-tooltip
                    class="item"
                    effect="light"
                    content="以成功邀请开卡的人数为准"
                    placement="bottom"
                  >
                    <el-button type="text" style="width: 40px">
                      <i style="color: #ccc" class="el-icon-question"></i>
                    </el-button>
                  </el-tooltip>
                </div>
                <div style="margin-bottom: 20px" class="line">
                  <div>奖品总份数：</div>

                  <el-input
                    @blur="beAdd(ruleForm.prizeCount, 'prizeCount')"
                    v-model="ruleForm.prizeCount"
                    @input="ruleForm.prizeCount = getNumberData($event, 0)"
                    style="width: 70px; margin: 0 10px"
                  ></el-input>
                  <div>份</div>
                </div>
                <el-button @click="centerVis">选择奖品</el-button>
                <div class="theLag" v-if="prizeSettingList.prizeType">
                  <div class="theBox">
                    <div
                      v-if="
                        prizeSettingList.prizeType != 3 &&
                        prizeSettingList.prizeType != 10
                      "
                      class="flex"
                      style="
                        margin: 30px 0 15px 0;
                        width: 280px;
                        justify-content: center;
                      "
                    >
                      <div class="price_sty">
                        {{ prizeSettingList.prizeTxt }}
                      </div>
                      <div
                        style="
                          height: 44px;
                          width: 1px;
                          background: #fe4d45;
                          opacity: 0.2;
                          margin: 0 12px;
                        "
                      ></div>
                      <div style="color: #999999">
                        {{ prizeSettingList.prizeType | prizeType }}
                      </div>
                    </div>
                    <p
                      v-else
                      style="
                        margin: 30px 0 25px 0;
                        width: 280px;
                        padding-left: 25px;
                        text-align: center;
                        text-overflow: -o-ellipsis-lastline;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 1;
                        line-clamp: 1;
                        -webkit-box-orient: vertical;
                      "
                    >
                      {{ prizeSettingList.title }}
                    </p>
                    <p class="pp">
                      {{ prizeSettingList.prizeType | prizeType }}
                    </p>
                  </div>
                  <div class="backgrd"></div>
                  <el-button
                    class="btnQx"
                    type="primary"
                    @click="deleteCoupon"
                    :disabled="isStartEdit"
                    >删除</el-button
                  >
                </div>
              </template>
              <template v-else>
                <div class="tips">
                  <div>
                    <img
                      src="@/assets/images/new_icon_waring_yellow.png"
                      style="
                        margin-right: 6px;
                        position: relative;
                        width: 14px;
                        height: 14px;
                        color: #ffb95e;
                      "
                    />
                    <span>温馨提示</span>
                  </div>
                  <div class="tipText">
                    <p>
                      1、邀请人数累计计算，达到邀请人数的最大人数并领取奖品后，可以继续邀请但是不能获得奖品
                    </p>
                    <p>
                      2、若勾选限制领取1次，则表示用户即使邀请足够多的好友完成助力条件，也只能在上述所有奖品中选择一件获得。
                    </p>
                    <p>
                      3、取消勾选领取限制，则表示用户在达成每个梯度的邀请条件后，均可获得奖品奖励。
                    </p>
                  </div>
                </div>
                <div>
                  <span>奖品库存显示：</span>
                  <el-radio
                    :disabled="isStartEdit"
                    v-model="isShowRemanentAmount"
                    :label="0"
                    >不显示</el-radio
                  >
                  <el-radio
                    :disabled="isStartEdit"
                    v-model="isShowRemanentAmount"
                    :label="1"
                    >显示</el-radio
                  >
                  <el-popover placement="top-start" trigger="hover" width="450">
                    <div>
                      <div>
                        选中“显示”，则活动用户可在活动页面中查看奖品的剩余库存。
                      </div>
                    </div>
                    <i
                      slot="reference"
                      style="color: #ccc; margin-left: 10px"
                      class="el-icon-question"
                    ></i>
                  </el-popover>
                </div>
                <el-table
                  :header-cell-style="{
                    'text-align': 'center',
                    'border-bottom': '2px solid #EBEEF5',
                  }"
                  :cell-style="{ 'text-align': 'center', overflow: 'visible' }"
                  :data="tableData"
                  border
                  style="width: 625px; overflow: visible"
                >
                  <el-table-column prop="date" label="邀请人数" width="110">
                    <template slot-scope="scope">
                      <el-input
                        :disabled="isStartEdit"
                        v-model="scope.row.peopleCount"
                        @input="
                          scope.row.peopleCount = getNumberData($event, 0)
                        "
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="name" label="奖品类型">
                    <template slot-scope="scope">
                      <span
                        style="color: #7f85e9; cursor: pointer"
                        v-if="
                          scope.row.prizeType == 3 || scope.row.prizeType == 10
                        "
                        @click="centerVis(scope)"
                        >{{ scope.row.title }}</span
                      >
                      <span
                        style="color: #7f85e9; cursor: pointer"
                        v-else-if="scope.row.prizeType"
                        @click="centerVis(scope)"
                        >{{ scope.row.prizeType | prizeType }}</span
                      >
                      <span
                        v-else
                        @click="centerVis(scope)"
                        style="color: #fe4d45; cursor: pointer"
                        >选择奖品</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column prop="price" width="110" label="值">
                  </el-table-column>
                  <el-table-column
                    prop="address"
                    width="145"
                    label="奖品总份数"
                  >
                    <template slot-scope="scope">
                      <el-input
                        @blur="beAdd(scope.row, 2)"
                        v-model="scope.row.prizeCount"
                        @input="
                          (e) =>
                            (scope.row.prizeCount = checkputnCount(
                              e,
                              scope.row,
                              'jindou'
                            ))
                        "
                        oninput="value=value.replace(/^0|[^\d]/g,'')"
                      ></el-input>
                      <div class="del_box">
                        <div class="delQx" @click="itemDel(scope.$index)">
                          <img src="@/assets/images/btn_del.svg" alt="" />
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
                <div @click="addPrizeRule" class="add_btn">
                  <img
                    style="width: 24px"
                    src="../../assets/images/btn_添加.svg"
                    alt=""
                  />
                  添加条件
                </div>
              </template>
            </div>
          </el-form-item>

          <el-form-item prop="limitReceive">
            <el-checkbox v-model="ruleForm.limitReceive" :disabled="isStartEdit"
              >限制领取1次</el-checkbox
            >
            <span class="warningTitele" style="width: 700px;">
              <i class="el-alert__icon el-icon-info" style="color: #ebaa3c"></i>
              勾选限制领取1次，则表示用户即使邀请足够多的好友完成助力条件，也仅能在所有奖品中选一件获得
            </span>
          </el-form-item>

          <el-form-item label="曝光商品:" class="zindexBox" prop="exposure">
            <el-checkbox v-model="ruleForm.exposureSwitch">
              是否添加曝光商品
            </el-checkbox>
            <el-button
              style="width: 155px; margin: 0 15px"
              @click="exposureProducts"
              :disabled="ruleForm.exposureSwitch == false"
            >
              {{
                itemListFor.length != ""
                  ? "添加曝光商品" + "(" + itemListFor.length + "/20" + ")"
                  : "添加曝光商品"
              }}
            </el-button>
            <!-- <el-radio-group v-model="ruleForm.radio" :disabled="ruleForm.exposureSwitch == false">
              <el-radio :label="0">显示淘宝价</el-radio>
              <el-radio :label="1">显示促销价</el-radio>
            </el-radio-group> -->
            <draggable
              v-if="itemListFor.length > 0"
              v-model="mainImagelist"
              chosen-class="chosen"
              :scroll="true"
              animation="150"
              force-fallback="true"
              @start="isDragging = true"
              @end="onEnd"
              style="
                margin-top: 10px;
                background: rgba(38, 112, 251, 0.06);
                padding: 10px 10px 0px 10px;
              "
            >
              <transition-group type="transition">
                <div
                  v-for="(item, index) in mainImagelist"
                  :key="item.skuId"
                  style="display: inline-block; position: relative"
                  class="show_upImg2"
                >
                  <img
                    :src="item.logo"
                    width="120px"
                    height="120px"
                    style="display: inline-block"
                  />&nbsp;
                  <!-- <div @click.stop="delec(index)" class="delectPosible">
                    <i class="el-icon-circle-close" style="font-size: 16px"></i>
                  </div> -->
                  <div class="delectPosible">
                    <span class="delectSort">拖动排序</span>
                    <img
                      src="@/assets/thdImg/pages/delet.svg"
                      @click.stop="delec(item, index)"
                      class="delectIcom"
                    />
                  </div>
                </div>
              </transition-group>
            </draggable>
          </el-form-item>
          <el-form-item label="活动规则:" required>
            <div
              style="
                width: 500px;
                backgroundcolor: rgba(250, 250, 250, 1);
                padding: 8px;
                position: relative;
              "
            >
              <el-input
                type="textarea"
                class="textarea"
                style="width: 484px"
                resize="none"
                v-model="ruleForm.activityRulesText"
                :maxlength="2000"
                :disabled="backgroundOpacity"
              ></el-input>
              <div class="prosi" style="color: #909399">
                （{{
                  ruleForm.activityRulesText.length
                    ? ruleForm.activityRulesText.length
                    : 0
                }}/2000）
              </div>
              <div>
                <el-button
                  type="primary"
                  class="generate"
                  plain
                  @click="generateRule"
                  :disabled="backgroundOpacity"
                >
                  生成规则
                </el-button>

                <span class="desc">
                  <i
                    class="el-alert__icon el-icon-info"
                    style="color: #999"
                  ></i>
                  点击按钮自动生成规则，也可以自己编辑信息
                </span>
              </div>
            </div>
          </el-form-item>
          <div v-if="backgroundOpacity" class="backgroundOpacity"></div>
        </el-form>
      </div>
    </div>
    <div class="create_bottom">
      <el-button
        v-show="!itemId"
        class="createBtn create_bottom_returnBtn"
        size="medium"
        @click="clickLocalStep()"
        >{{ backgroundOpacity ? "返回列表" : "返回上一步" }}</el-button
      >
      <template v-if="!backgroundOpacity">
        <el-button
          v-show="!itemId"
          v-if="isSave"
          class="createBtn create_bottom_keepBtn"
          type="primary"
          size="medium"
          @click="saveEdit"
          v-preventReClick
          >保存设置</el-button
        >
      </template>
      <el-button
        v-show="itemId"
        class="createBtn create_bottom_returnBtn"
        size="medium"
        @click="cancelEdit"
        >取消</el-button
      >
      <el-button
        v-show="itemId"
        class="createBtn create_bottom_keepBtn"
        type="primary"
        size="medium"
        >保存设置</el-button
      >
    </div>
    <!-- 添加曝光商品 -->
    <!-- <selectGoodsMonitor
      ref="selectGo"
      :isShow="selectGoodsState"
      @close="selectGoodsClose"
      :selectGoods="selectGoodsArr"
      :moduleType="true"
      :skuSearch="true"
      :xianz="true"
    ></selectGoodsMonitor> -->
    <selectGoodsMonitor
      v-if="selectGoodsState"
      @transferName="selectGoodsClose"
      :postForm="selectGoodsArr"
      :maxNum="20"
    >
    </selectGoodsMonitor>
    <!-- :skuSearch="true" -->
    <!-- 保存并完成设置弹框 -->
    <el-dialog title="重要提示" :visible.sync="joinBlackList" width="800">
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>

      <el-checkbox v-model="checked" label="地址" name="partner"
        >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
      >
      <div slot="footer" class="dialog-footer">
        <el-button @click="joinBlackList = false">取 消</el-button>
        <el-button @click="handleDialogCloseAnoth()" type="primary"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <!-- 选择奖品弹窗 -->
    <selectProduct
      :putPrize="putPrize"
      @close="colseDialog"
      v-if="showDialog"
      :tipShow="true"
      :picShow="true"
      ref="selectProduct"
      @choose-shop="getTheData"
    >
    </selectProduct>
  </div>
</template>

<script>
import {
  invite,
  editInvite,
  searchInvite,
  follow,
  editfollow,
  searchfollow,
  information,
  editInformationAa,
  searchInformation,
  creatPrize,
  editPrize,
  searchPrize,
} from "@/api/integralCenter/integralTask";
import {
  jingdouList,
  allAccountList,
  redPacketList,
} from "@/api/integralCenter/prizeCenter.js";
import { querymemberLevel } from "@/api/integralCenter/memberLevel";
import selectProduct from "./select_product";
import QRCode from "qrcodejs2";
import selectGoodsMonitor from "@/components/selectGoodsMonitor";
import draggable from "vuedraggable";
const prizeName = [
  "",
  "",
  "京豆",
  "实物",
  "店铺积分",
  "淘宝E卡",
  "爱奇艺会员",
  "淘宝PLUS会员",
  "现金红包",
];
export default {
  components: {
    selectProduct,
    selectGoodsMonitor,
    draggable,
  },
  created() {
    this.activityData = this.$route.query.activityData;
    this.localStepNum = this.activityData.id;
    console.log("this.$route.query------>", this.$route.query);
    console.log("this.localStepNum------>", this.localStepNum);
    if (this.$route.query.valueRow) {
      this.backgroundOpacity =
        this.$route.query.backgroundOpacity == "true" ? true : false;
      this.isSave = this.$route.query.isSave == "true" ? true : false;
      this.statusComment =
        this.$route.query.statusComment == "true" ? true : false;
      this.isStartEdit = this.$route.query.isStartEdit == "true" ? true : false;
      this.valueRow = this.$route.query.valueRow;
      this.activeValue = this.$route.query.activeValue;
      this.typeDetail();
    } else if (this.$route.query.copyParams) {
      // 复制
      this.isCopy = true;
      this.backgroundOpacity = false;
      this.isSave = true;
      this.statusComment = true;
      this.isStartEdit = false;
      this.valueRow = this.$route.query.copyParams.valueRow;
      this.activeValue = this.$route.query.copyParams.activeValue;
      this.typeDetail();
    } else {
      this.activityTimeChange();
    }
    console.log("this.activeValue222------>", this.activeValue);
  },
  filters: {
    prizeType(num) {
      var result = "";
      if (num == "2") {
        result = "京豆";
      } else if (num == "3") {
        result = "实物";
      } else if (num == "4") {
        result = "店铺积分";
      } else if (num == "5") {
        result = "淘宝E卡";
      } else if (num == "6") {
        result = "爱奇艺会员";
      } else if (num == "7") {
        result = "淘宝PLUS会员";
      } else if (num == "8") {
        result = "现金红包";
      } else if (num == "10") {
        result = "专属实物";
      }
      return result;
    },
  },
  mounted() {
    this.getLevel();
    // this.activityTimeChange();
    // this.$nextTick(() => {
    //   this.qrcodeAll(this.activityData.telCode, queryId);
    // });
    //存储拖拽前的数据
    this.mainImagelist = JSON.parse(sessionStorage.getItem("mainImagelist"));
    console.log(this.activeValue, 99996);
  },
  data() {
    return {
      crowdList: [],
      isShowRemanentAmount: 0,
      validOption: 0,
      filterInviteOption: 0,
      gradeOption: [],
      leveloptions: [],
      isStartEditTime: "",
      isStartEdit: false,
      valueRow: null,
      isCopy: false,
      telCode: "",
      localStep: 1,
      statusComment: false,
      localStepNum: 1,
      activityData: {
        id: 132,
      },
      activeValue: null,
      itemId: "",
      backgroundOpacity: false,
      isSave: true,
      stepNum: 1,
      //
      defaultTime: [
        this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length),
        this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length),
      ],
      activityTimeValue: this.$getDate(30),
      pickerOptionsValue: {
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 8.64e7 ||
            time.getTime() >
              new Date(this.$store.state.loginUserInfo.expiredIn).valueOf()
          );
        },
      },
      levelList: [],
      disableTime: false,
      clickActual: true,
      qrcode: null,
      order: "",
      showDialog: false,
      testInfo: [], //动态添加完善信息
      momentValue: {}, //编辑回显
      isShow: false,
      prizeSettingList: {
        price: null,
        title: "",
        assetsId: null,
        prizeType: null,
        logo: "",
        price: "",
        singleAmount: "",
      },
      //时间限制
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.ruleForm.activityStartTime) {
            return (
              time.getTime() <
              new Date(this.ruleForm.activityStartTime).getTime()
            );
          } else {
          }
        },
      },
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.ruleForm.activityEndTime) {
            return (
              time.getTime() > new Date(this.ruleForm.activityEndTime).getTime()
            );
          } else {
          }
        },
      },
      //每日签到
      checked: false,
      joinBlackList: false,
      draggingId: [], //有拖拽时要传的ID顺序
      saveValue: [],
      mainImagelist: [], //图片拖拽排序
      isDragging: false,
      itemListFor: [], //商品弹框选择商品数据
      selectGoodsState: false, //曝光商品弹窗
      selectGoodsArr: [],
      selectGoodsArr2: [],
      ele: "", //点击保存添加一行
      timeDay: 0, //活动持续天数
      timeOut: 0, //多少小时
      limit: true,
      itemArr: [
        {
          continueSignPoints: "",
          days: "",
        },
      ],
      itemArrOne: [],
      activityStartTime: null,
      activityEndTime: null,
      putPrize: {},
      ruleForm: {
        membershipTime:"",
        // 活动对象
        activityObject: 0,
        // 新老客户
        newOldCustomer: 0,
        //设置规则表单
        cutActivityWhileNoPrize: false, // 奖品领取完毕后，活动强制结束
        limitReceive: true, // 限制领取1次
        activityName: "",
        partner: ["-1"],
        isFollow: false,
        prizeSet: [],
        inputprize: "",
        exposureSwitch: false,
        radio: 0,
        startTime: "",
        prizeSite: "",
        information: [],
        activityStartTime: "", //活动开始时间
        activityEndTime: "", //活动结束时间
        singScore: null,
        activityRulesText: "", //生成规则
        bonusPoints: "", //活动名称，关注店铺有礼奖品设置积分
        peopleCount: "", //邀请开卡
        prizeSetOne: false,
        prizeCount: null,
        informationOne: [],
        isCumulativePrize: false,
      },
      tableData: [
        {
          peopleCount: "",
          prizeType: "",
          price: "",
          prizeCount: "",
          singleAmount: "",
        },
      ],
      tableIndex: null,
      rules: {
        // 表单规则校验
        activityName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          {
            min: 3,
            max: 50,
            message: "长度在 3 到 50 个字符",
            trigger: "blur",
          },
        ],
        isLongTime: [
          { required: true, message: "请选择活动时间", trigger: "change" },
        ],
        activityRulesText: [
          { required: true, message: "请填写活动规则", trigger: "blur" },
        ],
        partner: [
          {
            type: "array",
            required: true,
            message: "至少选择一个",
            trigger: "change",
          },
        ],
        prizeSet: [
          {
            type: "array",
            required: true,
            message: " ",
            trigger: "change",
          },
        ],
        startTime: [{ required: true, message: "请选择开始时间" }],
        choosePrize: [{ required: true, message: "请选择奖品" }],
        prizeCount: [{ required: true, message: "请输入奖品数量" }],
        prizeSite: [{ required: true, message: " ", trigger: "blur" }],
        information: [{ required: true, message: " " }],
      },
    };
  },
  computed: {
    selectCrowdText() {
      return this.crowdList.length === 0
        ? "选择人群"
        : `已选${this.crowdList.length}个`;
    },
  },
  watch: {
    // localStepNum(newVal) {
    //   if (newVal == 0) {
    //     this.$nextTick(() => {
    //       this.qrcodeAll(this.activityData.telCode, queryId);
    //     });
    //   }
    // },
  },
  methods: {
    handleActivityObj() {
      this.ruleForm.newOldCustomer = 0;
      this.ruleForm.partner = ["-1"];
      this.crowdList = [];
    },
    validOptionChange(e) {
      if (e == 0) {
        this.gradeOption = [];
      }
    },
    typeDetail() {
      if (this.activeValue == 5) {
        //邀请开卡
        searchInvite({ id: this.valueRow.id }).then((res) => {
          this.isShowRemanentAmount = res.data.ruleDto.isShowRemanentAmount
            ? res.data.ruleDto.isShowRemanentAmount
            : 0;
          this.ruleForm.isCumulativePrize = res.data.ruleDto.isCumulativePrize;
          this.filterInviteOption = res.data.ruleDto.filterInviteOption
            ? res.data.ruleDto.filterInviteOption
            : 0;
          this.validOption = res.data.ruleDto.validOption
            ? res.data.ruleDto.validOption
            : 0;
          this.gradeOption = res.data.ruleDto.gradeOption
            ? res.data.ruleDto.gradeOption.split(",")
            : [];
          if (res.data.ruleDto.isCumulativePrize) {
            this.ruleForm.limitReceive =
            res.data.ruleDto.limitReceive == 1 ? true : false;
            if (!this.isCopy) {
              this.tableData = res.data.ruleDto.cumulativePrizes.map(
                (item, index) => {
                  let obj = {
                    id: item.cumulativePrizeDTO.pointActivityPrizeId,
                    peopleCount: item.cumulativeNum,
                    title: item.cumulativePrizeDTO.title,
                    assetsId: item.cumulativePrizeDTO.assetsId,
                    prizeType: item.cumulativePrizeDTO.prizeType,
                    logo: item.cumulativePrizeDTO.logo,
                    price:
                      item.cumulativePrizeDTO.price ||
                      item.cumulativePrizeDTO.singleAmount,
                    singleAmount: item.cumulativePrizeDTO.singleAmount,
                    prizeCount: item.cumulativePrizeDTO.totalAmount,
                  };
                  return obj;
                }
              );
              this.tableData.forEach((item) => (item.minNum = item.prizeCount));
            } else {
              this.tableData = [
                {
                  peopleCount: "",
                  prizeType: "",
                  price: "",
                  prizeCount: "",
                  singleAmount: "",
                },
              ];
            }
          } else {
            let prize = res.data.ruleDto.cumulativePrizes;
            this.ruleForm.prizeCount = this.isCopy
              ? null
              : prize[0].cumulativePrizeDTO.totalAmount;
            this.ruleForm.minNum = this.isCopy
              ? null
              : prize[0].cumulativePrizeDTO.totalAmount;
            if (!this.isCopy) {
              this.prizeSettingList = {
                id: prize[0].cumulativePrizeDTO.pointActivityPrizeId,
                singleAmount: prize[0].cumulativePrizeDTO.singleAmount,
                title: prize[0].cumulativePrizeDTO.title,
                assetsId: prize[0].cumulativePrizeDTO.assetsId,
                prizeType: prize[0].cumulativePrizeDTO.prizeType,
                logo: prize[0].cumulativePrizeDTO.logo,
                price: prize[0].cumulativePrizeDTO.price,
                discount: prize[0].cumulativePrizeDTO.singleAmount,
              };
            } else {
              this.prizeSettingList = {
                price: null,
                title: "",
                assetsId: null,
                prizeType: null,
                logo: "",
                price: "",
                singleAmount: "",
              };
            }
            this.setPrizeTxt(this.prizeSettingList);
            this.ruleForm.peopleCount = this.isCopy
              ? ""
              : res.data.ruleDto.maxInviteNum || "";
          }
          this.activityTimeValue = [
            String(res.data.startTime),
            String(res.data.endTime),
          ];
          if (this.isStartEdit) {
            //进行中活动 无法修改活动开启时间
            this.isStartEditTime = String(res.data.startTime);
          }
          this.ruleForm.activityName = res.data.activityName;
          this.ruleForm.activityStartTime = String(res.data.startTime);
          this.ruleForm.activityEndTime = String(res.data.endTime);
          this.ruleForm.activityObject = res.data.hasOwnProperty(
            "activityObject"
          )
            ? res.data.activityObject
            : 0;
          this.ruleForm.newOldCustomer = res.data.hasOwnProperty(
            "newOldCustomer"
          )
            ? Number(res.data.newOldCustomer)
            : 0;
          this.crowdList =
            res.data.hasOwnProperty("seniorGroupId") && res.data.seniorGroupId
              ? res.data.seniorGroupId.split(",")
              : [];
          this.ruleForm.activityRulesText = this.isCopy
            ? ""
            : String(res.data.ruleDescription); //生成规则
          this.ruleForm.partner = res.data.allowLevel.split(",");
          this.ruleForm.membershipTime = res.data.membershipTime
          this.ruleForm.exposureSwitch =
            res.data.isExposureItem == 0 ? false : true;
          this.ruleForm.cutActivityWhileNoPrize =
            res.data.ruleDto.cutActivityWhileNoPrize == 1 ? true : false;
          // 商品处理
          let shopList = res.data.itemList
            ? res.data.itemList.map((item) => {
                return {
                  ...item,
                  numIid: item.wareId,
                  itemTitle: item.title,
                  picUrl: item.logo,
                };
              })
            : [];
          this.selectGoodsArr = shopList;
          this.itemListFor = shopList;
          this.mainImagelist = shopList;
          this.ruleForm.radio = res.data.priceType;
          this.activityTimeChange();
        });
      }
    },
    // 活动进行中修改奖品数量
    beAdd(row, type) {
      console.log("活动进行中修改奖品数量", row, type);
      if (this.isStartEdit) {
        if (row && type == 1) {
          if (row.minNum && Number(row.totalAmount) < Number(row.minNum)) {
            row.totalAmount = row.minNum;
            this.$message.warning("为避免客诉，奖品数量不能小于之前哦~");
          }
        } else if (row && type == 2) {
          if (row.minNum && Number(row.prizeCount) < Number(row.minNum)) {
            row.prizeCount = row.minNum;
            this.$message.warning("为避免客诉，奖品数量不能小于之前哦~");
          }
        } else if (type == "bonusPoints") {
          console.log("this.ruleForm.minNum", this.ruleForm.minNum);
          console.log("this.ruleForm.bonusPoints", this.ruleForm.bonusPoints);
          if (
            this.ruleForm.minNum &&
            Number(this.ruleForm.bonusPoints) < Number(this.ruleForm.minNum)
          ) {
            this.ruleForm.bonusPoints = this.ruleForm.minNum;
            this.$message.warning("为避免客诉，奖品数量不能小于之前哦~");
          }
        } else if (type == "prizeCount") {
          if (
            this.ruleForm.minNum &&
            Number(this.ruleForm.prizeCount) < Number(this.ruleForm.minNum)
          ) {
            this.ruleForm.prizeCount = this.ruleForm.minNum;
            this.$message.warning("为避免客诉，奖品数量不能小于之前哦~");
          }
        }
      }
    },
    limitInput(event) {
      if (event.target.value == "0") {
        event.target.value = "";
      } else {
        event.target.value = event.target.value.replace(/[^\d]/g, "");
      }
    },
    itemDel(index) {
      if (this.tableData.length == 1) {
        this.$message.warning("梯度奖品必须有一个奖项");
        return;
      }
      this.tableData.splice(index, 1);
      console.log(this.tableData);
      // delete this
    },
    addPrizeRule() {
      if (this.isStartEdit) return;
      this.tableData.push({
        peopleCount: "",
        prizeType: "",
        value: "",
        prizeCount: "",
      });
    },
    colseDialog() {
      this.showDialog = false;
      this.clickActual = true;
      console.log("clickActual", this.clickActual);
    },
    //会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          console.log(res, 6667);
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
          this.leveloptions = res.data;
          console.log(this.levelList, 111112);
        })
        .catch((res) => {});
    },
    //生成二维码
    qrcodeAll(val, queryId) {
      this.qrcode = new QRCode(queryId, {
        width: 117, // 设置宽度，单位像素
        height: 117, // 设置高度，单位像素
        text: val, // 设置二维码内容或跳转地址
      });
    },
    checkputn(e) {
      let filtered = e.target.value.replace(/^0|[^\d]/g, "");
      e.target.value = Number(filtered);
      console.log(filtered, e.target.value, this.ruleForm.peopleCount);
      // //下边写用户输入时需要的执行逻辑
      // if(this.ruleForm.inputprize!= filtered) {
      //     this.ruleForm.inputprize = filtered
      // }
      // 不能输入0，绑定的值如果小于1，那么输入框置空
      if (e.target.value < 1) {
        e.target.value = "";
      }
    },
    //清空商品数据
    deleteCoupon() {
      this.prizeSettingList.price = null;
      this.prizeSettingList.title = "";
      this.prizeSettingList.assetsId = null;
      this.prizeSettingList.prizeType = null;
    },
    //选择商品数据
    getTheData(data, prizeType) {
      console.log(data, prizeType, "data132456789");
      this.colseDialog();
      this.showDialog = false;
      console.log(this.tableIndex);

      // v3.4邀请开卡
      /**
       * @param singleAmount 积分数，京豆数  其余奖项为1
       */
      // 梯度奖励
      if (this.ruleForm.isCumulativePrize == true) {
        this.tableData[this.tableIndex].prizeType = prizeType;
        this.tableData[this.tableIndex].price =
          data.discount || data.singleAmount;
        this.tableData[this.tableIndex].singleAmount = data.singleAmount;
        this.tableData[this.tableIndex].title = data.name || prizeType;
        this.tableData[this.tableIndex].assetsId = Number(data.couponId);
        this.tableData[this.tableIndex].logo = data.logo;
        if (prizeType == 2) {
          this.tableData[this.tableIndex].quantityTotal = data.quantityTotal;
        }
        if (prizeType == 10) {
          this.tableData[this.tableIndex].price = data.price;
          this.tableData[this.tableIndex].title = data.itemTitle;
          this.tableData[this.tableIndex].assetsId = data.id;
          this.tableData[this.tableIndex].logo = data.picUrl;
        }
      } else {
        console.log(1111);
        this.prizeSettingList.singleAmount = 1;
        this.prizeSettingList.assetsId = Number(data.couponId);
        this.prizeSettingList.prizeType = prizeType;
        this.prizeSettingList.logo = data.logo;
        this.prizeSettingList.title = data.name || prizeType;
        this.prizeSettingList.price = data.discount;
        if (prizeType == 4) {
          this.prizeSettingList.title = prizeType;
          this.prizeSettingList.price = data.discount;
          this.prizeSettingList.singleAmount = data.singleAmount;
        } else if (prizeType == 2) {
          this.prizeSettingList.singleAmount = data.singleAmount;
          this.prizeSettingList.couponType = data.couponType;
          this.prizeSettingList.title = prizeType;
          this.prizeSettingList.quantityTotal = data.quantityTotal;
        } else if (prizeType == 10) {
          this.prizeSettingList.title = data.itemTitle;
          this.prizeSettingList.assetsId = Number(data.id);
          this.prizeSettingList.logo = data.picUrl;
        }
        this.setPrizeTxt(this.prizeSettingList);
        console.log(this.prizeSettingList);
      }
    },
    setPrizeTxt(item) {
      if (item.prizeType == 8) {
        item.prizeTxt = item.price + "元";
      } else if (
        item.prizeType == 7 ||
        item.prizeType == 6 ||
        item.prizeType == 5
      ) {
        item.prizeTxt = item.price;
      } else {
        item.prizeTxt = item.singleAmount;
      }
    },
    //模板下一步
    nextStep() {
      this.localStepNum = this.activityData.id;
      this.localStep = 1;
      this.$emit("titopName", this.activityData.name, true);
    },
    //弹框确认
    handleDialogCloseAnoth() {
      this.ruleForm.activityStartTime = this.activityTimeValue[0];
      this.ruleForm.activityEndTime = this.activityTimeValue[1];
      //日历签到
      let everyDay = {
        activityName: this.ruleForm.activityName, //活动名称
        allowLevel: this.ruleForm.partner.join(","), //参与会员等级：-1(全部)，0(非会员)，其余填会员等级
        condFollow: this.ruleForm.isFollow == true ? 1 : 0, //参与条件
        endTime: this.ruleForm.activityEndTime, //活动结束时间
        activityObject: this.ruleForm.activityObject,
        membershipTime:this.ruleForm.membershipTime,
        newOldCustomer: this.ruleForm.newOldCustomer,
        seniorGroupId: this.crowdList.join(","),
        isExposureItem: this.ruleForm.exposureSwitch == false ? 0 : 1, //是否曝光商品：0否,1是
        itemList: this.itemListFor.map((item) => {
          return {
            logo: item.logo,
            price: item.price,
            title: item.title,
            skuId: item.skuId,
            wareId: item.numIid,
          };
        }), //曝光商品集合
        points: Number(this.ruleForm.inputprize), //单次奖励积分
        priceType: this.ruleForm.radio, //曝光商品价格显示：0显示淘宝价，1显示促销价
        pointActivityPrizeDTO: {
          //选择奖品数据
          price: this.prizeSettingList.price,
          title: this.prizeSettingList.title,
          assetsId: this.prizeSettingList.assetsId,
          prizeType: this.prizeSettingList.prizeType,
          logo: this.prizeSettingList.logo,
          couponType: this.prizeSettingList.couponType,
        },
        ruleDTO: {
          //规则拓展信息
          continueRule: this.itemArr,
          requestFollow: this.ruleForm.isFollow, //是否关注
          startTime: this.ruleForm.startTime,
          prizeCount: Number(this.ruleForm.prizeCount),
        },
        ruleDescription: this.ruleForm.activityRulesText, //规则拓展信息
        startTime: this.ruleForm.activityStartTime, //活动开始时间
      };
      //编辑回显
      this.momentValue = everyDay;
      //对象排序(根据对象的某一属性)
      if (this.draggingId.length != []) {
        let a = this.draggingId;
        let b = [];
        for (let i = 0; i < a.length; i++) {
          this.itemListFor.find((obj) => {
            // if (obj.wareId == a[i]) {
            //   b.push({
            //     logo: obj.logo,
            //     price: obj.price,
            //     title: obj.title,
            //     wareId: obj.wareId,
            //   });
            // }
            if (obj.skuId == a[i]) {
              b.push({
                logo: obj.logo,
                price: obj.price,
                title: obj.title,
                skuId: obj.skuId,
                wareId: obj.numIid,
              });
            }
          });
        }
        everyDay.itemList = b;
      }
      //活动名称的限制
      if (
        !this.ruleForm.activityName ||
        this.ruleForm.activityName.length == 0
      ) {
        this.$message.warning("请输入活动名称");
        return;
      }
      //活动时间的限制
      if (!this.ruleForm.activityStartTime || !this.ruleForm.activityEndTime) {
        this.$message.warning("请输入活动时间");
        return;
      }

      if (this.validOption == 1 && this.gradeOption.length == 0) {
        this.$message.warning("勾选等级不能为空");
        return;
      }

      if (!this.ruleForm.activityRulesText) {
        this.$message.warning("活动规则不能为空");
        return;
      }
      //判断勾选提示后即可调取接口
      if (this.checked == true) {
        //通过活动来调取不一样的接口
        if (this.activityData.name == "邀请开卡有礼") {
          everyDay.ruleDTO = {};
          // 接口需要，points固定传个正数
          everyDay.points = 1;
          everyDay.ruleDTO.cutActivityWhileNoPrize = this.ruleForm
            .cutActivityWhileNoPrize
            ? 1
            : 0;
          everyDay.ruleDTO.maxInviteNum = this.ruleForm.peopleCount;
          everyDay.ruleDTO.isCumulativePrize = this.ruleForm.isCumulativePrize;
          (everyDay.ruleDTO.filterInviteOption = this.filterInviteOption),
            (everyDay.ruleDTO.validOption = this.validOption),
            (everyDay.ruleDTO.gradeOption = this.gradeOption.join(",")),
            delete everyDay.pointActivityPrizeDTO;
          // 梯度奖励
          if (this.ruleForm.isCumulativePrize) {
            console.log(" this.tableData", this.tableData);
            everyDay.ruleDTO.limitReceive = this.ruleForm.limitReceive ? 1 : 0;
            everyDay.ruleDTO.cumulativePrizes = this.tableData.map((item) => {
              let prize = {
                pointActivityPrizeId: item.id,
                title: item.title,
                assetsId: item.assetsId,
                prizeType: item.prizeType,
                singleAmount: item.singleAmount,
                totalAmount: item.prizeCount,
              };
              if (prize.prizeType == 3 || prize.prizeType == 10) {
                prize.logo = item.logo;
              }
              if (prize.prizeType != 2 && prize.prizeType != 4) {
                console.log(item.price);
                prize.price = item.price;
              }
              return {
                cumulativeNum: item.peopleCount,
                cumulativePrizeDTO: prize,
              };
            });
            everyDay.ruleDTO.maxInviteNum =
              this.tableData[this.tableData.length - 1].peopleCount;
            console.log(everyDay.ruleDTO.cumulativePrizes);
          } else {
            console.log("this.prizeSettingList.id", this.prizeSettingList);
            let prize = {
              pointActivityPrizeId: this.prizeSettingList.id,
              title: this.prizeSettingList.title,
              assetsId: this.prizeSettingList.assetsId,
              prizeType: this.prizeSettingList.prizeType,
              logo: this.prizeSettingList.logo,
              singleAmount: this.prizeSettingList.singleAmount,
              totalAmount: this.ruleForm.prizeCount,
            };
            if (prize.prizeType == 3) {
              prize.logo = this.prizeSettingList.logo;
            }
            if (prize.prizeType != 2 && prize.prizeType != 4) {
              prize.price = this.prizeSettingList.price;
            }

            everyDay.ruleDTO.cumulativePrizes = [
              {
                cumulativeNum: 1,
                cumulativePrizeDTO: prize,
              },
            ];

            console.log(this.prizeSettingList, 123);
          }
          everyDay.ruleDTO.isShowRemanentAmount = this.isShowRemanentAmount;
          // 编辑
          if (this.activeValue == 5 && !this.isCopy) {
            everyDay.pointActivityId = this.valueRow.id;
            editInvite(everyDay)
              .then((res) => {
                if (res.code == 1) {
                  this.$emit("saveEdit");
                  this.$router.push({ path: "activeList" });
                  this.$message.success(res.message);
                } else {
                  this.$message.error(res.message);
                }
              })
              .catch(() => {});
          } else {
            invite(everyDay)
              .then((res) => {
                if (res.code == 1) {
                  this.$emit("saveEdit");
                  this.$router.push({ path: "activeList" });
                  this.$message.success(res.message);
                } else {
                  this.$message.error(res.message);
                }
              })
              .catch(() => {});
          }
        }
        this.joinBlackList = false;
        return;
      } else {
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    // 检查奖品总数
    async checkedPrizeCount(item) {
      // const typeArr = ['','','jingdouList','3','4','allAccountList','allAccountList','allAccountList','redPacketList']
      await this.setPromise(item);

      // console.log(res);
      // res.filter(i=>{
      //   if (i==item.priceType) {

      //   }
      // })
    },
    setPromise(item) {
      if (item.priceType == 2) {
        return new Promise((resolve, reject) => {
          const formLitJD = {
            current: 1,
            size: 100,
            isFilterUsed: true,
            status: 2,
          };
          jingdouList(formLitJD)
            .then((res) => {
              res.filter((i) => {
                // 对应的计划
                if (i.id == item.assetsId) {
                  // 奖品总份数为空
                  if (!item.totalAmount) {
                  }
                }
              });
              resolve(res);
            })
            .catch((res) => {});
        });
      }
    },
    // getJingdouList() {
    //   jingdouList(this.formLitJD)
    //     .then((res) => {
    //       let selectArr = res.data.records.map((item) => {
    //         return {
    //           label: item.planName,
    //           value: item.id,
    //         };
    //       });
    //       this.selectList = selectArr;
    //       this.planList.jingdou = res.data.records
    //     })
    //     .catch((res) => {});
    // },
    //时间
    clearTime(a, b) {
      this.ruleForm.activityStartTime = null;
      this.ruleForm.activityEndTime = null;
    },
    //删除
    delec(item, index) {
      let i = -1;
      this.mainImagelist.forEach((items, index1) => {
        if (items.skuId == item.skuId) i = index1;
      });
      if (i != -1) {
        this.mainImagelist.splice(i, 1);
        this.itemListFor = this.mainImagelist;
        // this.itemListFor.splice(i, 1);
      }
      console.log(this.mainImagelist, 4444444);
    },
    //完善信息删除
    deleteaInfo(index) {
      this.itemArrOne.splice(index, 1);
    },
    //图片拖拽
    onEnd() {
      this.isDragging = false;
      //拖拽完成后的顺序
      let arr = [];
      this.mainImagelist.forEach((item) => {
        // arr.push(item.wareId);
        arr.push(item.skuId);
        this.draggingId = arr;
      });
    },
    //商品回调
    selectGoodsChange(val) {
      this.goodsState = false;
    },
    centerVis(scope) {
      if (this.isStartEdit) return;
      console.log(scope.$index);
      // 梯度奖品
      if (scope.$index || scope.$index == 0) {
        this.tableIndex = scope.$index;
        // 点击到已选实物奖品的条件，不置灰实物tab
        console.log(this.tableData[scope.$index].prizeType);
        if (this.tableData[scope.$index].prizeType == 3) {
          this.clickActual = false;
        }
      }

      if (this.isCumulativePrize) {
        this.putPrize = this.tableData[this.tableIndex];
      } else {
        this.putPrize = this.prizeSettingList;
      }
      this.showDialog = true;
      this.$nextTick(() => {
        this.$refs.selectProduct.openDialog();
        if (scope && (scope.$index || scope.$index == 0)) {
          this.$refs.selectProduct.physicalGift(scope.row)
        }else{
          this.$refs.selectProduct.physicalGift(this.prizeSettingList)
        }
      });
    },
    //连续签到送积分
    signInpoints(val) {
      this.ruleForm.singScore = val;
    },
    //连续签到删除
    deletea(index) {
      this.itemArr.splice(index, 1);
    },
    //添加条件
    addCondition() {
      let parm = {
        continueSignPoints: this.itemArr.continueSignPoints,
        days: this.itemArr.days,
      };
      this.ele++;
      this.ele = parm;
      this.itemArr.push(this.ele);
    },
    //完善信息的添加
    perfectAdd() {
      let valueParm = {
        informationmation: this.itemArrOne.informationmation,
        informationmationOne: this.itemArrOne.informationmationOne,
      };
      this.element++;
      this.element = valueParm;
      this.itemArrOne.push(this.element);
    },
    //奖品设置
    prizeSetChange(val) {
      if (val == true) {
        this.limit = false;
      } else {
        this.limit = true;
        this.ruleForm.inputprize = "";
      }
    },
    //活动时间驱动
    activityTimeChange(val) {
      if (this.isStartEdit) {
        //进行中活动 无法修改活动开启时间
        this.activityTimeValue[0] = this.isStartEditTime;
      }
      this.ruleForm.activityStartTime = this.activityTimeValue[0];
      this.ruleForm.activityEndTime = this.activityTimeValue[1];
      let nowTime = new Date().getTime();
      let start = new Date(this.ruleForm.activityStartTime).valueOf();
      let end = new Date(this.ruleForm.activityEndTime).valueOf();
      let invalidateDate = new Date(
        this.$store.state.loginUserInfo.expiredIn
      ).valueOf();
      if (this.backgroundOpacity) {
        var datas, change1, change2, days, daysStart, daysEnd, date3;
        daysStart = this.ruleForm.activityStartTime.substring(0, 10);
        daysEnd = this.ruleForm.activityEndTime.substring(0, 10);
        if (
          this.ruleForm.activityEndTime != "" &&
          this.ruleForm.activityStartTime != ""
        ) {
          datas = daysEnd.split("-");
          change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
          datas = daysStart.split("-");
          change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
          days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);
          this.timeDay = days;
          //计算小时
          date3 =
            new Date(this.ruleForm.activityEndTime).getTime() -
            new Date(this.ruleForm.activityStartTime).getTime();
          var leave1 = date3 % (24 * 3600 * 1000);
          this.timeOut = Math.floor(leave1 / (3600 * 1000));
        } else {
          this.timeOut = 0;
          return;
        }
        return;
      }
      if (end > invalidateDate) {
        this.$message.warning("活动时间不能超过软件有效期，请重新选择");
        this.activityTimeValue[1] = "";
        this.ruleForm.activityEndTime = null;
        return;
      }
      if (start < nowTime) {
        if (this.activeValue) {
          this.disableTime = true;
        } else {
          if (!this.isStartEdit) {
            this.$message.warning("开始时间不能小于当前时间");
          }
          // this.ruleForm.activityStartTime = null;
          // return;
        }
      }
      if (end < nowTime) {
        this.$message.warning("结束时间不能小于当前时间");
        // this.ruleForm.activityEndTime = null;
        // return;
      }
      if (end < start) {
        this.$message.warning("结束时间不能小于开始时间");
        // this.activityTimeValue[1] = "";
        // this.ruleForm.activityEndTime = null;
        return;
      }
      var datas, change1, change2, days, daysStart, daysEnd, date3;
      daysStart = this.ruleForm.activityStartTime.substring(0, 10);
      daysEnd = this.ruleForm.activityEndTime.substring(0, 10);
      if (
        this.ruleForm.activityEndTime != "" &&
        this.ruleForm.activityStartTime != ""
      ) {
        datas = daysEnd.split("-");
        change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        datas = daysStart.split("-");
        change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);
        this.timeDay = days;
        //计算小时
        date3 =
          new Date(this.ruleForm.activityEndTime).getTime() -
          new Date(this.ruleForm.activityStartTime).getTime();
        var leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
      } else {
        this.timeOut = 0;
        return;
      }
      if (
        this.ruleForm.activityEndTime &&
        this.ruleForm.activityStartTime &&
        this.ruleForm.activityEndTime.substring(0, 10) ==
          this.ruleForm.activityStartTime.substring(0, 10)
      ) {
        this.$message.warning("活动时间不能小于一天");
        this.activityTimeValue[1] = "";
        this.ruleForm.activityEndTime = "";
      }
    },
    // 返回上一步
    returnBack() {
      this.$emit("returnBack");
    },
    // 取消编辑
    cancelEdit() {
      this.$emit("cancelEdit");
    },
    //保存编辑
    saveEdit() {
      // console.log(this.ruleForm.isCumulativePrize);
      let state = true;
      if (this.ruleForm.activityObject == 2 && !this.crowdList.length) {
        return this.$message.error("请完善活动对象信息！");
      }
      if (this.ruleForm.isCumulativePrize) {
        let arr = this.tableData.map((i) => {
          return i.peopleCount;
        });
        if (arr.indexOf("") != -1) {
          return this.$message.error("邀请人数不可为空");
        }
        var flagSort = false;
        for (let i = 0; i < arr.length; i++) {
          if (arr[i + 1]) {
            if (Number(arr[i]) >= Number(arr[i + 1])) {
              flagSort = true;
              break;
            }
          }
        }
        if (flagSort) {
          return this.$message.error("邀请人数梯度不可小于或等于上一个梯度");
        }

        for (let index = 0; index < arr.length; index++) {
          const element = arr[index];
          if (this.tableData[index].prizeType == "") {
            return this.$message.error("请在条件中设置奖品");
          }
          for (
            let indexSecond = index;
            indexSecond < arr.length;
            indexSecond++
          ) {
            console.log(element, arr[indexSecond], element > arr[indexSecond]);
            if (Number(element) > Number(arr[indexSecond])) {
              state = false;
            }
          }
        }
        if (!state) {
          return this.$message.error("邀请人数梯度不可小于上一个梯度");
        }
      }
      // console.log(this.ruleForm.informationOne);
      // console.log(this.itemArrOne);
      this.joinBlackList = true;
      // this.$emit("saveEdit");
    },
    // 下一步
    resetForm() {
      this.joinBlackList = true;
    },
    //添加曝光商品弹窗
    exposureProducts() {
      this.selectGoodsState = true;
      // console.log(this.itemListFor);
      if (this.itemListFor.length == 0) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
      // debugger
      // this.$refs.selectGo.handleRightCurrentChange(1);
      // console.log(this.selectGoodsArr);
      // return
    },
    selectGoodsSure(data) {
      if (!data) {
        this.selectGoodsState = false;
        return;
      }
    },
    selectGoodsClose(event, index) {
      // console.log(data);
      // // debugger
      // if (data) {
      //   console.log(data);
      //   this.itemListFor = [];
      //   this.mainImagelist = [];
      //   data.forEach((value, index) => {
      //     let fomeVaule = {};
      //     fomeVaule.skuId = data[index].skuId;
      //     fomeVaule.logo = data[index].logo;
      //     fomeVaule.price = data[index].jdPrice || data[index].price;
      //     fomeVaule.title = data[index].wareTitle || data[index].title;
      //     this.itemListFor.push(fomeVaule);
      //     this.mainImagelist.push(fomeVaule);
      //   });
      //   this.selectGoodsArr = this.itemListFor;
      // }
      if (typeof event != "boolean") {
        let newArr = event;
        // event.forEach((item) => {
        //   newArr.push(item.numIid);
        // });
        if (index && index == 1) {
          this.itemListFor = newArr;
          this.mainImagelist = newArr;
          this.selectGoodsArr = newArr;
        }
      }
      // console.log(this.selectGoodsArr, this.itemListFor, 3333);
      this.selectGoodsState = false;
    },
    //选中改变
    checkListchange(val) {
      console.log(val);
      console.log(this.levelList);
      val.forEach((low) => {
        if (low == -1) {
          this.ruleForm.partner = ["-1"];
        }
      });
    },
    //生成规则
    generateRule() {
      //活动规则判断
      let oldValue = this.ruleForm;
      let text1 = "",
        text2 = "",
        text3 = "",
        text4 = "",
        text5 = "",
        text6 = "",
        text7 = "",
        text8 = "",
        text9 = "";
      //活动名称
      if (this.ruleForm.activityName.length > 0) {
        text1 = "活动名称：" + this.ruleForm.activityName;
      }
      //活动时间
      if (this.ruleForm.activityStartTime && this.ruleForm.activityEndTime) {
        text2 =
          "活动时间：" +
          this.ruleForm.activityStartTime +
          "~" +
          this.ruleForm.activityEndTime;
      }
      //参与对象
      if (this.ruleForm.partner.length > 0) {
        let levelText = [];
        this.ruleForm.partner.forEach((item, index) => {
          if (item == -1) {
            item = "全部";
          } else if (item == 0) {
            item = "非会员";
          } else {
            this.levelList.forEach((it, index) => {
              if (index + 1 == item) {
                item = it;
              }
            });
          }
          levelText.push(item);
        });

        text4 = "活动参与对象：" + levelText.splice(",");
      }
      let text34 = ""
      if (this.ruleForm.activityObject == "1" && this.ruleForm.membershipTime && this.ruleForm.partner!=[0]){
        text34 = `入会时间：${this.ruleForm.membershipTime}之后入会的会员可参与活动`
      }

      if (this.activityData.name == "邀请开卡有礼") {
        console.log(this.ruleForm);
        if (!this.ruleForm.isCumulativePrize) {
          let prizeText =
            this.prizeSettingList.singleAmount +
            prizeName[this.prizeSettingList.prizeType];
          if (this.prizeSettingList.prizeType == 3) {
            prizeText = this.prizeSettingList.title;
          } else {
            prizeText =
              this.prizeSettingList.prizeTxt +
              prizeName[this.prizeSettingList.prizeType];
          }
          text6 = "奖品设置：" + "每邀请一人可获得" + prizeText + ",";

          if (this.ruleForm.peopleCount) {
            text6 +=
              "活动期间最多邀请" +
              this.ruleForm.peopleCount +
              "人" +
              "," +
              "超出人数不再获得奖励";
          }
        } else {
          console.log(this.tableData);
          let textArr = this.tableData.map((i) => {
            let prizeText =
              i.prizeType == 3
                ? i.title
                : i.price + "" + prizeName[i.prizeType];
            let str = `邀请${i.peopleCount}人可获得${prizeText}`;
            return str;
          });
          console.log(textArr);
          text6 = "奖品设置：" + textArr.join("，") + "，超出人数不再获得奖励";
        }
      }
      let levetList = [];
      let levetListOne = [];
      let levetListTwo = "";
      let levetListThree = "";
      this.ruleForm.information.forEach((o, x) => {
        if (o == -1) {
          o = "全部";
        }
        levetListOne.push(o);
      });
      this.itemArrOne.forEach((v, i) => {
        levetList.push(v.informationmationOne);
      });
      levetListTwo = levetListOne.join(",");
      levetListThree = levetList.join(",");
      if (levetListTwo.length != "" && levetListThree.length == 1) {
        levetListThree = "";
      }
      if (levetListTwo.length != "" && levetListThree.length > 1) {
        levetListTwo = levetListOne.join(",") + ",";
      }
      text7 = "分享给好友后，需要好友点击进入并开卡成功才算邀请成功";
      text8 = "奖品数量有限，先到先得";
      text9 =
        "如果被邀请人在邀请过程中开过店铺会员或品牌会员的卡，需要重新回到被邀请人页面，邀请人才能获得奖励！";
      // let Arr1 = [
      //   text1,
      //   text2,
      //   text3,
      //   text4,
      //   text5,
      //   text6,
      //   text7,
      //   text8,
      //   text9,
      // ];
      let Arr1
      if (this.ruleForm.limitReceive && this.ruleForm.isCumulativePrize) {
        Arr1 = [
          text1,
          text2,
          text3,
          text4,
          text34,
          text5,
          text6,
          "达成多个阶梯邀请奖励时，仅能从多个奖品中挑选一个进行领取",
          text7,
          text8,
          text9,
        ];
      } else {
        Arr1 = [text1, text2, text3, text4,text34, text5, text6, text7, text8, text9];
      }
      let newText = "";
      let newNum = 1;
      Arr1.forEach((item) => {
        if (item.length > 0) {
          newText = newText + newNum + "." + item + ";" + "\n";
          newNum = newNum + 1;
        }
      });
      this.ruleForm.activityRulesText = newText;
    },
    // 返回上一步
    clickLocalStep() {
      sessionStorage.setItem("goBack", this.activityData.goIndex);
      if (this.$route.query.copyParams && this.$route.query.copyParams.isCopy) {
        sessionStorage.setItem("goBackCopy", true);
      }
      this.$router.go(-1);
      // if (this.backgroundOpacity) {
      //   this.$emit("returnBack");
      //   return;
      // }
      // this.localStep = 0;
      // this.localStepNum = 0;
      // this.$emit("titopName", this.activityData.name, false);
    },
    checkputnCount(e, row) {
      if (row.quantityTotal && row.price && row.prizeCount) {
        let numTotal = this.$jingdouTotal(row);
        if (!numTotal) {
          this.$message.warning("京豆总份额数量不能大于该京豆预算额！");
        }
        return numTotal;
      } else {
        return row.prizeCount;
      }
    },
    // 品牌定制弹窗
    handleOpen() {
      const href =
        "tencent://message/?uin=800152084&Site=%E5%9C%A8%E7%BA%BF%E5%AE%A2%E6%9C%8D&Menu=yes";
      window.open(href, "_self");
    },
  },
};
</script>

<style lang="scss" scoped>
.warningTitele {
  width: 380px;
  height: 42px;
  background: #fdf6ec;
  border-radius: 4px;
  line-height: 42px;
  display: block;
  padding-left: 15px;
  margin: 10px 0 6px;
}
/deep/ .el-table__row:hover {
  .delQx {
    display: flex;
  }
}
.startTime {
  /deep/ .el-table__body-wrapper {
    padding-left: 30px !important;
  }
}
.prosi {
  position: absolute;
  bottom: 45px;
  right: 20px;
}
.delectPosible:hover {
  -webkit-box-shadow: #ccc 0px 1px 1px;
  -moz-box-shadow: #ccc 0px 1px 1px;
  box-shadow: #ccc 0px 1px 1px;
}
.flex {
  display: flex;
  align-items: center;
}
.del_box {
  position: absolute;
  left: 145px;
  top: 15px;
  width: 50px;
  height: 50px;
}
.delQx {
  width: 25px;
  height: 25px;
  background: rgb(255, 76, 68);
  display: inline-block;
  display: none;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  img {
    width: 50px;
    margin-right: 4px;
  }
  // display: none;
}
.prize_box {
  padding: 26px 21px;
  background: #fcfcfc;
  .tips {
    > div:first-child {
      display: flex;
      align-items: center;
    }
    .tipText {
      display: flex;
      flex-direction: column;
      padding-left: 20px;
      font-size: 12px;
      font-weight: 400;
    }
    width: 650px;
    // align-items: flex-start;
    box-sizing: border-box;
    background: #fffaee;
    border-radius: 3px;
    font-size: 14px;
    font-weight: 400;
    color: #333;
    margin-bottom: 9px;
  }
  .add_btn {
    cursor: pointer;
    color: #7f85e9;
    border: 1px dashed #7f85e9;
    width: 625px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 8px;
  }
}
.line {
  display: flex;
  align-items: center;
}
.createPlayStep {
  min-width: 1360px;
  position: relative;
  box-sizing: border-box;
  min-height: 80vh;
  height: 88.5vh;
  background-color: #fff;
  // box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  margin: 24px;
  .headReturn {
    box-sizing: border-box;
    padding-left: 30px;
    width: 100%;
    height: 50px;
    line-height: 49px;
    border-bottom: 1px solid #f3f3f3;
    span {
      color: #ccc;
      cursor: pointer;
    }
    .name {
      color: #333;
      cursor: default;
    }
  }
  .step {
    padding: 30px 24px 0;
    .bz {
      display: flex;
      justify-content: center;
      height: 18px;
      // border-bottom: 1px solid #f3f3f3;
      margin-left: 11%;
    }
  }
  .firststep {
    min-height: 820px;
    box-sizing: border-box;
    padding: 35px 35px 0;
    .itemList {
      display: flex;
      .item {
        box-sizing: border-box;
        position: relative;
        color: #666;
        text-align: center;
        padding: 6px;
        &:hover {
          .border::before,
          .border::after {
            opacity: 1;
            transform: scale(1);
          }
        }
        .border {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          border-radius: 4px;
          &::before,
          &::after {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            content: "";
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.8s, transform 0.8s;
            border-radius: 4px;
          }
          &::before {
            border-top: 1px solid #fe4d45;
            border-bottom: 1px solid #fe4d45;
            -webkit-transform: scale(0, 1);
            transform: scale(0, 1);
          }
          &::after {
            border-right: 1px solid #fe4d45;
            border-left: 1px solid #fe4d45;
            -webkit-transform: scale(1, 0);
            transform: scale(1, 0);
          }
        }
        .wrapper {
          position: relative;
          height: 350px;
          border-radius: 6px;
          overflow: hidden;
          .queryId {
            display: none;
          }
          &:hover {
            .queryId {
              display: block;
            }
            .mask {
              opacity: 1;
            }
          }
          .mask {
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.6);
            color: #fff;
            opacity: 0;
            transition: all 0.2s;
            .img {
              max-width: 130px;
              margin: 0 auto 30px;
              .imgBg {
                box-sizing: border-box;
                height: 129px;
                width: 129px;
                padding: 6px;
                border-radius: 6px;
                background-color: #fff;
              }
              .tpl {
                display: inline-block;
                margin-top: 10px;
                color: #fff;
                // opacity: 0.7;
              }
            }
          }
        }
      }
    }
  }
  .secondstep {
    // min-height: 870px;
    box-sizing: border-box;
    position: relative;
    padding: 0px 28px 1px 24px;
    // margin-bottom: 29px;
    .time2 {
      width: 54px;
      height: 28px;
      border-radius: 4px;
      display: inline-block;
      text-align: center;
      line-height: 28px;
    }
    .generate {
      width: 76px;
      margin: 8px 8px 0 0;
      background: rgba(38, 112, 251, 0.1);
      border: 1px solid #2670fb;
      color: #2670fb;
      border-radius: 4px;
    }
    .lastTime {
      margin-left: 20px;
      font-size: 14px;
      i {
        color: #ccc;
      }
    }
    .theLag {
      position: relative;
      margin-top: 10px;
      height: 142px;
      width: 302px;
      .theBox {
        height: 142px;
        width: 302px;
        // border: 1px solid #999;
        background: url("../../assets/thdImg/pages/yhq.svg") no-repeat;
        border-radius: 8px;
        position: absolute;
        color: #333333;
        .price_sty {
          font-family: DIN;
          font-weight: bold;
          color: #2670fb;
          font-size: 45px;
        }
        .pp {
          width: 280px;
          text-align: center;
          bottom: 0px;
        }
      }

      .btnQx {
        display: none;
      }
      &:hover {
        .btnQx {
          display: block;
          position: absolute;
          top: 50%;
          left: 50%;
          margin: -16px 0 0 -49px;
        }
        .backgrd {
          width: 302px;
          height: 142px;
          background: #fff;
          position: absolute;
          border-radius: 8px;
          opacity: 0.7;
        }
      }
    }

    .productImg {
      margin-top: 10px;
      background-color: #fafafa;
      min-height: 80px;
      width: 800px;
      border-radius: 5px;
    }
    .desc {
      i {
        opacity: 0.7;
        color: #fe4d45;
      }
      color: #999;
    }
    .returnBtn {
      width: 148px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(254, 77, 69, 1);
      color: #fe4d45;
      transition: all 0.2s;
      &:hover {
        background-color: #fe4d45;
        color: #fff;
      }
    }
    .keepBtn {
      margin-left: 30px;
      width: 188px;
      background-color: #fe4d45;
      color: #fff;
      transition: all 0.2s;
      &:hover {
        opacity: 0.9;
      }
    }
  }
}
.wrapper-kaika {
  width: 100%;
  height: 100%;
  display: grid;
  // align-items: center;
  // justify-content: center;

  &-img {
    background-color: #fafafa;
    border: 2px solid rgba(254, 77, 69, 0.0784313725490196);
    border-radius: 8px;
    height: 350px;
    // margin-right: 20px;
    position: relative;
    &:hover {
      .borderkaika::before,
      .borderkaika::after {
        opacity: 1;
        transform: scale(1);
      }
    }
    .borderkaika {
      position: absolute;
      left: -6px;
      top: -6px;
      width: 218px;
      height: 360px;
      border-radius: 4px;
      &::before,
      &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        content: "";
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.8s, transform 0.8s;
        border-radius: 4px;
      }
      &::before {
        border-top: 1px solid #fe4d45;
        border-bottom: 1px solid #fe4d45;
        -webkit-transform: scale(0, 1);
        transform: scale(0, 1);
      }
      &::after {
        border-right: 1px solid #fe4d45;
        border-left: 1px solid #fe4d45;
        -webkit-transform: scale(1, 0);
        transform: scale(1, 0);
      }
    }

    div {
      font-size: 18px;
      font-weight: bold;
      // line-height: 25px;
      color: #333333;
    }
    img {
      width: 32px;
      height: 32px;
    }

    .queryIdIMG {
      display: none;
    }
    &:hover {
      .queryIdIMG {
        display: block;
      }
      .mask {
        opacity: 1;
      }
    }
    .mask {
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.6);
      color: #fff;
      opacity: 0;
      transition: all 0.2s;
      .img {
        max-width: 130px;
        margin: 0 auto 30px;
        .imgBg {
          box-sizing: border-box;
          height: 129px;
          width: 129px;
          padding: 6px;
          border-radius: 6px;
          background-color: #fff;
        }
        .tpl {
          display: inline-block;
          font-size: 14px;
          color: #fff;
          margin-top: 10px;
          // opacity: 0.7;
        }
      }
    }
  }
  &-tanchuang {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .lijijq {
    &::after {
      content: "立即领取";
      display: block;
      position: absolute;
      bottom: 9px;
      left: 51%;
      transform: translateX(-50%);
      font-size: 14px;
      font-family: system-ui;
      font-weight: bold;
      color: #ed6e09;
      text-shadow: 0 0 black;
    }
  }
}
.margin-left-8 {
  margin-left: 8px;
}
.margin-left-12 {
  margin-left: 12px;
  i {
    cursor: pointer;
    color: #ccc;
  }
}
.tips-style {
  color: #cccccc;
}
</style>
